export function Badge({ s }) {
  const colors = { ok: 'var(--green)', error: 'var(--red)', running: 'var(--accent)', warning: 'var(--yellow)' };
  return <span style={{ padding: '3px 8px', fontSize: 10, fontFamily: 'var(--mono)', letterSpacing: 1, borderRadius: 2, background: (colors[s]||'var(--muted)') + '22', color: colors[s]||'var(--muted)', textTransform: 'uppercase' }}>{s}</span>;
}
